<div #toolbarPortal class="full-flex-width"></div>
